import { Contract, ethers } from "ethers";
import { getAllowance, getDecimals, setApprove } from "../ethereumFunctions";

import Web3 from "web3";

const INVEST = require("./Invest.json");
const ERC20 = require("../build/ERC20.json");

export async function getInvestors(accountAddress, contractAddress) {
  const web3 = new Web3(window.ethereum);
  const contract = new web3.eth.Contract(INVEST.abi, contractAddress);

  let investors = await contract.methods.investors(accountAddress).call();

  return investors;
}

export async function getTotalInvest(contractAddress) {
  const web3 = new Web3(window.ethereum);
  const contract = new web3.eth.Contract(INVEST.abi, contractAddress);

  let investAmount = await contract.methods.totalInvestAmount().call();

  return investAmount;
}

export async function investToken(
  reseller,
  coinAmount,
  coinAddress,
  contractAddress,
  ethAmount,
  accountAddress,
  callback
) {
  const web3 = new Web3(window.ethereum);
  const token = new web3.eth.Contract(ERC20.abi, coinAddress);
  const tokenDecimals = await getDecimals(token);
  const amount = ethers.utils.parseUnits(coinAmount, tokenDecimals);
  const approveAmount =
    "115792089237316195423570985008687907853269984665640564039457584007913129639935";

  let gas_price = await web3.eth.getGasPrice();
  let options = {
    from: accountAddress,
    gasPrice: gas_price * 1.5,
    value: ethAmount,
  };

  const beforeAllowance = await getAllowance(
    token,
    accountAddress,
    contractAddress
  );

  if (+beforeAllowance >= +coinAmount) {
    const contract = new web3.eth.Contract(INVEST.abi, contractAddress);
    await contract.methods
      .invest(`${+amount}`, reseller)
      .send(options)
      .then(() => {
        callback({ status: true });
      })
      .catch((e) => {
        console.log(e);
        callback({ status: false, e });
      });
  } else {
    // const approveAmount = Math.pow(2, 256);
    await setApprove(token, accountAddress, contractAddress, approveAmount);

    let allowanceInterval = setInterval(async () => {
      const allowance = await getAllowance(
        token,
        accountAddress,
        contractAddress
      );

      if (+allowance >= +coinAmount) {
        clearInterval(allowanceInterval);

        const contract = new web3.eth.Contract(INVEST.abi, contractAddress);
        await contract.methods
          .invest(`${+amount}`, reseller)
          .send(options)
          .then(() => {
            callback({ status: true });
          })
          .catch((e) => {
            console.log(e);
            callback({ status: false, e });
          });
      }
    }, 5000);
  }
}

export async function getCalculateReward(
  index,
  accountAddress,
  contractAddress
) {
  const web3 = new Web3(window.ethereum);
  const contract = new web3.eth.Contract(INVEST.abi, contractAddress);

  let reward = await contract.methods
    .calculateReward(accountAddress, index)
    .call();

  return reward;
}

export async function getInvestedList(accountAddress, contractAddress) {
  const web3 = new Web3(window.ethereum);
  const contract = new web3.eth.Contract(INVEST.abi, contractAddress);

  let list = [];
  let finished = false;

  for (let i = 0; i < 1000; i++) {
    const element = i;

    if (!finished) {
      await contract.methods
        .getInvestmentDetails(accountAddress, element)
        .call()
        .then(async (res) => {
          list.push({
            id: element,
            amount: +res.amount,
            startTime: +res.startTime,
            totalRewards: +res.totalRewards,
            lastRewardTime: +res.lastRewardTime,
          });
        })
        .catch((e) => {
          finished = true;
        });
    } else {
      break;
    }
  }

  return list;
}

export async function harvestToken(
  accountAddress,
  contractAddress,
  contractIndex
) {
  const web3 = new Web3(window.ethereum);
  const contract = new web3.eth.Contract(INVEST.abi, contractAddress);

  let gas_price = await web3.eth.getGasPrice();
  let options = {
    from: accountAddress,
    gasPrice: gas_price * 1.5,
  };

  console.log(options, `${contractIndex}`);

  await contract.methods.withdrawReward(`${contractIndex}`).send(options);
}

export async function exitInvest(
  accountAddress,
  contractAddress,
  contractIndex
) {
  const web3 = new Web3(window.ethereum);
  const contract = new web3.eth.Contract(INVEST.abi, contractAddress);

  let gas_price = await web3.eth.getGasPrice();
  let options = {
    from: accountAddress,
    gasPrice: gas_price * 1.5,
  };

  console.log(options, `${contractIndex}`);

  await contract.methods.redeemInvestment(`${contractIndex}`).send(options);
}
